<p>Selecione o período desejado</p>

<p-datepicker
  dateFormat="dd/mm/yy"
  selectionMode="range"
  [(ngModel)]="rangeDates"
  [readonlyInput]="true"
  (onClose)="setDateRange()" />

<p-table>
  <ng-template #header>
    <tr>
      <th>Nome</th>
      <th>Status</th>
      <th>Desconto</th>
      <th>Acumulado de Uso<br />(Sem desconto)</th>
      <th>Quantidade de uso</th>
      <th>Valor Adquirido</th>
      <th>Parceiro</th>
    </tr>

    <ng-container *ngFor="let coupon of coupons">
      <tr>
        <td>{{ coupon.name }}</td>
        <td>ativo</td>
        <td *ngIf="coupon.percentage_discount; else elseBlock">
          {{ coupon.percentage_discount }}%
        </td>
        <ng-template #elseBlock>
          <td>{{ coupon.fixed_discount ?? 0 | currency : "BRL" }}</td>
        </ng-template>
        <td>{{ coupon.total_value | currency : "BRL" }}</td>
        <td>{{ coupon.usage_count ?? 0 }}</td>
        <td>{{ (coupon.total_value ?? 0) * 0.1 | currency : "BRL" }}</td>
        <td>{{ coupon.account?.username }}</td>
      </tr>
    </ng-container>
  </ng-template>
</p-table>
